import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { MovTable } from "@/pages/ReceiptDetail";
import { Search } from "lucide-react";

export default function Movements() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  async function load() {
    const params = q ? { internal_batch: q } : {};
    const { data } = await api.get("/stock/movements", { params });
    setRows(data);
  }
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-5">
      <div><h1 className="font-heading text-2xl font-extrabold">Mutasi Bahan</h1>
        <p className="text-sm text-muted-foreground">Seluruh pergerakan stok: masuk, keluar (FIFO), dan koreksi.</p></div>
      <Card className="p-4">
        <div className="relative max-w-sm mb-4">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input data-testid="mov-search" placeholder="Filter batch internal..." value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} className="pl-9" />
        </div>
        <table className="w-full text-sm">
          <thead><tr className="text-left text-muted-foreground border-b">
            <th className="py-2 font-medium">Batch</th><th className="font-medium">Bahan</th><th className="font-medium">Jenis</th>
            <th className="font-medium">Masuk</th><th className="font-medium">Keluar</th><th className="font-medium">Saldo</th><th className="font-medium">Ref</th>
          </tr></thead>
          <tbody>
            {rows.map((m) => (
              <tr key={m.id} className="border-b border-slate-100 dark:border-slate-800">
                <td className="py-2"><span className="batch-chip">{m.internal_batch}</span></td>
                <td>{m.material_name}</td>
                <td><span className={`text-xs px-2 py-0.5 rounded font-medium ${m.type === "IN" ? "bg-emerald-100 text-emerald-700" : m.type === "OUT" ? "bg-red-100 text-red-700" : "bg-slate-100 text-slate-600"}`}>{m.type}</span></td>
                <td>{m.qty_in || "-"}</td><td>{m.qty_out || "-"}</td><td className="font-medium">{m.balance_after}</td><td className="text-xs">{m.reference}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="py-6 text-center text-muted-foreground">Belum ada mutasi.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
